/** Full Name — underlined text input (design tokens; renders inside .askk-theme). */
import { FieldError, FieldLabel } from './FieldLabel'

interface Props {
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
  error?: string
}

export function NameField({ value, onChange, onBlur, error }: Props) {
  return (
    <label className="flex flex-col gap-1.5">
      <FieldLabel required>Full Name</FieldLabel>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        placeholder="Enter your name"
        autoComplete="name"
        className="border-0 border-b border-textSeparator bg-transparent pb-2 text-labelLarge text-textPrimary placeholder:text-textDisabled focus:border-textAccentPrimary focus:outline-none"
      />
      <FieldError message={error} />
    </label>
  )
}
